import { apiService } from './api'

class ReportService {
  async getUserReports(params?: any) {
    const response = await apiService.api.get('/admin/reports/users', { params })
    return response.data
  }

  async getUserReportDetail(id: number) {
    const response = await apiService.api.get(`/admin/reports/users/${id}`)
    return response.data
  }

  async getMessageReports(params?: any) {
    const response = await apiService.api.get('/admin/reports/messages', { params })
    return response.data
  }

  async getMessageReportDetail(id: number) {
    const response = await apiService.api.get(`/admin/reports/messages/${id}`)
    return response.data
  }

  async getReportStats() {
    const response = await apiService.api.get('/admin/reports/stats')
    return response.data
  }

  async updateUserReportStatus(id: number, status: string) {
    const response = await apiService.api.patch(`/admin/reports/users/${id}/status`, { status })
    return response.data
  }

  async updateMessageReportStatus(id: number, status: string) {
    const response = await apiService.api.patch(`/admin/reports/messages/${id}/status`, { status })
    return response.data
  }

  async blockUser(reportId: number, userId: number, action: 'block' | 'unblock', reason?: string, blockedUntil?: string) {
    const response = await apiService.api.patch(`/admin/reports/users/${reportId}/block-user`, { userId, action, reason, blockedUntil })
    return response.data
  }

  async deleteReportedMessage(reportId: number) {
    const response = await apiService.api.delete(`/admin/reports/messages/${reportId}/message`)
    return response.data
  }

  async deleteUserReport(id: number) {
    const response = await apiService.api.delete(`/admin/reports/users/${id}`)
    return response.data
  }

  async deleteMessageReport(id: number) {
    const response = await apiService.api.delete(`/admin/reports/messages/${id}`)
    return response.data
  }
}

export const reportService = new ReportService()
export default reportService
